<template>
  <el-dialog
    title="数据导入"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" label-width="100px">
      <el-form-item label="模版下载">
        <el-button
          size="small"
          type="primary"
          @click="downloadTemplate"
        >
          下载
        </el-button>
      </el-form-item>
      <el-form-item label="文件上传">
        <el-button
          size="small"
          type="primary"
          @click="selectFile"
        >
          上传
        </el-button>
        <div class="upload-area">
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            action="#"
            accept=".xlsx,.xls"
            :limit="1"
            :file-list="fileList"
            :http-request="uploadExcel"
            :on-remove="handleRemove"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处,或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :loading="submitting"
      >
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  importLegalStatusAPI,
  importDebtTransferStatusAPI,
} from "../api/data-import";

export default {
  name: "DataImport",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 导入类型: 'legal' - 法诉状态导入, 'debt' - 债转状态导入
    importType: {
      type: String,
      default: "legal",
      validator: (value) => ["legal", "debt"].includes(value),
    },
    // 模板下载URL
    templateUrl: {
      type: String,
      default: "/static/售后状态.xlsx",
    },
    // 模板文件名
    templateFileName: {
      type: String,
      default: "售后状态.xlsx",
    },
  },
  data() {
    return {
      dialogVisible: false,
      file: null,
      fileList: [],
      submitting: false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (!val) {
        this.reset();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    downloadTemplate() {
      const a = document.createElement("a");
      a.href = this.templateUrl;
      a.download = this.templateFileName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectFile() {
      this.$refs.upload.$refs["upload-inner"].handleClick();
    },
    uploadExcel(param) {
      this.file = param.file;
    },
    handleRemove() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    async handleSubmit() {
      if (!this.file) {
        this.$message.error("请选择文件");
        return;
      }

      this.submitting = true;
      try {
        const formData = new FormData();
        formData.append("file", this.file);
        
        // 根据导入类型调用不同的API
        if (this.importType === "legal") {
          await importLegalStatusAPI(formData);
        } else if (this.importType === "debt") {
          await importDebtTransferStatusAPI(formData);
        }
        
        this.$message.success("文件上传成功");
        this.handleClose();
        this.$emit("success");
      } catch (error) {
        this.$message.error("文件上传失败");
      } finally {
        this.submitting = false;
      }
    },
    reset() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-area {
  margin-top: 10px;
}
</style>

